import { render } from "./CharaSelect.vue?vue&type=template&id=2a5bca81&scoped=true"
import script from "./CharaSelect.vue?vue&type=script&lang=js"
export * from "./CharaSelect.vue?vue&type=script&lang=js"

import "./CharaSelect.vue?vue&type=style&index=0&id=2a5bca81&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a5bca81"]])

export default __exports__